module.exports = __webpack_public_path__ + "img/say-hello-to-new-people.f305a91c.svg";